import React, { useEffect, useState } from "react";

const Banner = ({ id, name, type, image: file, time, changeStep }) => {
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    // Activa la animación de la barra al montar el banner.
    setAnimate(true);

    // Dispara changeStep cuando transcurra el tiempo estipulado.
    const timer = setTimeout(() => {
      changeStep();
    }, time * 1000);

    return () => clearTimeout(timer);
  }, [time, changeStep]);

  return (
    <div className="banner">
      {type === "image" && <img src={file} alt={name} />}
      {type === "video" && <video autoPlay src={file} alt="videoName" />}
      <div className="banner_percentage">
        <div
          className={`banner_percentage-bar ${animate ? "play" : ""}`}
          style={{ transition: `width ${time}s linear` }}
        ></div>
      </div>
    </div>
  );
};

export default Banner;
